import React from 'react';

interface StyledHtmlContentProps {
  html: string;
  className?: string;
}

const StyledHtmlContent: React.FC<StyledHtmlContentProps> = ({ html, className = '' }) => {
  const styledHtml = html
    .replace(/<a /g, '<a style="text-decoration: underline; margin: 0 4px; color: #f97316" ');

  return (
    <div 
      className={className}
      dangerouslySetInnerHTML={{ __html: styledHtml }}
    />
  );
};

export default StyledHtmlContent;
